export const basketUrl = (lang = 'pl_PL', currency = 'PLN'): string => `/webapi/front/${lang}/basket/${currency}/`;
